import React from "react";
import { Network } from "../../services/NetworkApi";
import { COLOR_WHITE } from "../../constants/styles";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { useNetwork } from "../../hooks/useNetwork";
import { usePaginationHandler } from "../../hooks/usePaginationHandler";
import { Table } from "../../UI/Table";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { Typography } from "../../UI/Typography";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { TableHeader } from "../TableHeader";
import { TablePagination } from "../TablePagination";
import { useTablePaginationContext } from "../TablePagination/context";
import { SetAllToButtons } from "./SetAllToButtons";
import { StatusSwitch } from "./StatusSwitch";

export const KnowBeforeRoomsyncRulesTable = () => {
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { getL2s } = useNetwork();
  const l2s = getL2s(selectedNetworkId);
  const { page, setPage, perPage, setPages } = useTablePaginationContext();
  const { selectedRows, pages } = usePaginationHandler(l2s, page, perPage);

  const isReadOnly = (l2: Network) => (l2.matchingRoundStatus === "ARCHIVED" || l2.matchingRoundStatus === "CLOSED");


  React.useEffect(() => {
    setPages(pages);
    setPage(1);
  }, [pages.length]);

  return (
    <>
      <TableHeader endAdornment={<SetAllToButtons subnetworks={l2s} />}>
        <Typography fontWeight={600} color={COLOR_WHITE}>
          Known Before Roomsync
        </Typography>
      </TableHeader>
      <Table>
        <TableHead secondary>
          <TableRow>
            <TableCell>Matching Round </TableCell>
            <TableCell>Enabled</TableCell>
          </TableRow>
        </TableHead>
        <EnhancedTableBody colSpan={2}>
          {selectedRows.map((l2) => (
            <TableRow key={l2.l2Id}>
              <TableCell>{l2.l2Name}</TableCell>
              <TableCell>
                <StatusSwitch
                  l2Id={l2.l2Id}
                  defaultValue={l2.previouslyKnownEnabled}
                  isDisabled={isReadOnly(l2)}
                />
              </TableCell>
            </TableRow>
          ))}
        </EnhancedTableBody>
      </Table>
      <TablePagination />
    </>
  );
};
